var _defs, _polyline, _line, _polyline2, _polyline3, _path, _path2, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _line2, _line3, _rect10, _polyline10, _path3, _rect11, _rect12, _line4, _line5, _line6, _line7, _line8, _line9, _line10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPcbangmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1520.41 653.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-1,.cls-5{stroke-width:6px;}.cls-2{stroke-width:4px;}.cls-3,.cls-4{stroke-width:3px;}.cls-4{stroke-dasharray:5.08 5.08;}.cls-5{opacity:0.57;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "914.57 106.37 1460.06 3.51 1517.4 340.74 1509.57 528.37 1333.57 528.37 1333.57 650.37 922.57 636.37 922.57 599.37 871.57 599.37 871.57 634.37 3.57 611.37 8.57 583.37 56.57 538.37"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 859.57,
    y1: 123.37,
    x2: 501.57,
    y2: 123.37
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.57 495.37 34.57 430.37 85.57 123.37 449.57 123.37"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "58.31 287.46 101.57 291.37 86.57 377.37 44.05 373.3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337,361l27-7s51.89,78,22.45,172.5S362,633,362,633H337s0-46,21.11-106.5C367.24,500.32,395,462,337,361Z",
    transform: "translate(-171.43 -199.63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.59,628H303s13-53,27.52-100.39C357.13,440.77,342,454,303,371.6l35.2-6.6",
    transform: "translate(-171.43 -199.63)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "120.56 611.4 121.25 588.3 166.01 589.65 165.32 612.75"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "165.54 612.78 166.23 589.69 222.99 591.4 222.29 614.5"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "222.92 614.58 223.62 591.48 257.97 592.52 257.27 615.62"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "257.76 620.49 258.6 592.6 322.94 594.54 322.1 622.43"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "501.55 123.37 502.57 123.37 502.57 447.37 449.57 447.37 449.57 175.37"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "451.57 175.71 235.57 175.71 235.57 123.02 451.57 123.02"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 585.57,
    y: 123.37,
    width: 52,
    height: 324
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 637.57,
    y: 123.37,
    width: 52,
    height: 324
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 830.33,
    y: 617.04,
    width: 52,
    height: 371.06,
    transform: "translate(1508.04 -233.64) rotate(91.39)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1274.04,
    y: 608.98,
    width: 52,
    height: 409.84,
    transform: "translate(1973.86 -665.62) rotate(91.39)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 848.57,
    y: 223.37,
    width: 52,
    height: 182
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 900.57,
    y: 223.37,
    width: 52,
    height: 182
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1153,
    y: 547,
    width: 52,
    height: 172,
    transform: "translate(1640.57 -745.63) rotate(90)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1350.53,
    y: 255.24,
    width: 52,
    height: 324,
    transform: "translate(-227.27 86.25) rotate(-11.62)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1401.47,
    y: 244.76,
    width: 52,
    height: 324,
    transform: "translate(-224.11 96.29) rotate(-11.62)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1459.72,
    y1: 332.86,
    x2: 1399.57,
    y2: 14.37
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1459.21,
    y1: 330.92,
    x2: 1445.06,
    y2: 528.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 450.57,
    y: 407.37,
    width: 51,
    height: 40
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "501.57 120.37 501.57 154.37 449.57 154.37 449.57 120.37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M658.36,323",
    transform: "translate(-171.43 -199.63)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 865.57,
    y: 407.37,
    width: 56,
    height: 47
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1420,
    y: 592,
    width: 41,
    height: 34,
    transform: "translate(-264.59 103.07) rotate(-11.62)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 900.72,
    y1: 46.36,
    x2: 901.34,
    y2: 48.78
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.6,
    y1: 53.7,
    x2: 914.56,
    y2: 100.47
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 915.19,
    y1: 102.93,
    x2: 915.81,
    y2: 105.36
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 858.57,
    y1: 123.37,
    x2: 917.57,
    y2: 105.37
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 842.57,
    y1: 64.37,
    x2: 843.19,
    y2: 66.79
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 844.45,
    y1: 71.71,
    x2: 856.41,
    y2: 118.48
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 857.04,
    y1: 120.94,
    x2: 857.66,
    y2: 123.37
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcbangmap);
export default __webpack_public_path__ + "static/media/pcbangmap.2c591ebcec7fe0394693befb04b949ee.svg";
export { ForwardRef as ReactComponent };